<template>
  <div class="container-box">
    <div class="main">
      <div class="filter">
        <van-row>
          <!-- <van-col span="12">
            <van-field v-model="form.wz" placeholder="请输入物资名称" />
          </van-col> -->
          <van-col span="12" class="ss_col">
            <!-- <van-field
              readonly
              clickable
              name="picker"
              :value="nameObj.classificationCode"
              placeholder="请选择通用名"
              @click="showPickerFn('classificationCode')"
            /> -->
            <Select
              v-model="form.classificationCode"
              url="/emm/emmStockInfo/emmSpecification"
              :params="{ status: 0 }"
              keys="classificationCode"
              showName="classificationName"
              :searchMode="true"
              placeholder="请选择通用名"
              @change="
                () => {
                  form.codes = '';
                  $refs.Select.into();
                }
              "
            >
            </Select>
          </van-col>
          <van-col span="12" class="ss_col">
            <Select
              ref="Select"
              v-model="form.codes"
              url="/emm/emmStockInfo/emmSpecification"
              :params="{
                status: 1,
                classificationCode: form.classificationCode,
              }"
              keys="emmCode"
              showName="alias"
              :searchMode="true"
              placeholder="请选择物资品名"
            >
            </Select>
            <!-- <van-field
              readonly
              clickable
              name="picker"
              :value="nameObj.codes"
              placeholder="请选择物资品名"
              @click="showPickerFn('codes')"
            /> -->
          </van-col>
          <van-col span="12">
            <van-field
              readonly
              clickable
              name="picker"
              :value="nameObj.storageLevel"
              placeholder="请选择储备性质"
              @click="showPickerFn('storageLevel')"
            />
          </van-col>
          <van-col span="12">
            <van-field
              readonly
              clickable
              name="picker"
              :value="nameObj.manageMode"
              placeholder="请选择管理方式"
              @click="showPickerFn('manageMode')"
            />
          </van-col>
        </van-row>
        <div class="filter-btn">
          <div class="scan">
            <!-- <van-button type="info" size="small">69码查询</van-button> -->
            <!-- <input
              class="scan-ipt"
              ref="file"
              type="file"
              accept="image/*"
              capture="user"
            /> -->
          </div>
          <van-button type="info" size="small" @click="getData()"
            >查询</van-button
          >
          <van-button type="warning" size="small" @click="reset"
            >重置</van-button
          >
        </div>
      </div>
      <div class="table-box">
        <div class="table">
          <el-table
            border
            :header-cell-style="headerStyle"
            height="100%"
            :data="tableData"
            v-loading="loading"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column
              v-for="(row, index) in tableColumns"
              :prop="row.prop"
              :label="row.text"
              :width="row.width"
              :key="index"
              align="center"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="50"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="handleDetail(scope.row)"
                  type="text"
                  size="small"
                >
                  展开
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <van-pagination
          v-model="currentPage"
          :page-count="pageCount"
          mode="simple"
        />
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showDetail" position="bottom" style="height: 60%">
      <div
        style="padding: 8px 10px; display: flex; justify-content: space-between"
      >
        <div>{{detailData.alias}}</div>
        <div>
          <van-icon
            name="close"
            size="20"
            color="#6D748D"
            @click="showDetail = false"
          />
        </div>
      </div>
      <div class="popup-table">
        <el-table
          border
          :header-cell-style="headerStyle"
          height="100%"
          :data="detailData.items"
          v-loading="loading"
        >
          <el-table-column
            v-for="(row, index) in detailColumns"
            :prop="row.prop"
            :label="row.text"
            :width="row.width"
            :key="index"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </van-popup>
  </div>
</template>
<script>
import request from "@/utils/http";

export default {
  data() {
    return {
      loading: false,
      value: "",
      classificationCode: [],
      codes: [],
      storageLevel: [],
      manageMode: [
        { value: "", text: "无" },
        { value: 1, text: "储备" },
        { value: 2, text: "配备" },
      ],
      columns: [],
      showPicker: false,
      tableColumns: [
        { prop: "additionalInfo.alias", text: "物资品名", width: 150 },
        { prop: "additionalInfo.brand", text: "品牌", width: 100 },
        { prop: "additionalInfo.model", text: "型号", width: 100 },
        { prop: "stockNum", text: "库存量", width: 80 },
        { prop: "total", text: "总价（元）", width: 100 },
        {
          prop: "additionalInfo.classificationName",
          text: "通用名",
          width: 100,
        },
        { prop: "storageLevel", text: "储备性质", width: 80 },
        { prop: "manageMode", text: "管理方式", width: 80 },
        { prop: "additionalInfo.enterpriseName", text: "归属单位", width: 150 },
      ],
      detailColumns: [
        { prop: "productDate", text: "生产日期", width: 100 },
        { prop: "stockNum", text: "库存量", width: 100 },
        { prop: "price", text: "单价（元）", width: 100 },
        { prop: "totals", text: "总价（元）", width: 100 },
        { prop: "clientName", text: "生产厂家", width: 100 },
        { prop: "stCode", text: "库房", width: 100 },
        { prop: "locCode", text: "库位", width: 100 },
      ],
      tableData: [],
      AllData: [],
      form: {
        classificationCode: null,
        codes: "",
        storageLevel: "",
        manageMode: "",
      },
      field: "",
      nameObj: {
        storageLevel: "",
      },
      curData: {},
      showDetail: false,
      detailData: {
        items:[]
      },
      stCode: [],
      currentPage: 1,
      pageCount: 1,
    };
  },
  watch: {
    currentPage(val) {
      this.getData(val);
    },
  },
  methods: {
    headerStyle() {
      return { background: "#f2f2f2", color: "#39506E" };
    },
    getSt() {
      return request.get("/emm/storehouse/getStByWarehouseId").then((res) => {
        this.stCode = res.data.map((item) => ({
          value: item.stCode,
          text: item.stName,
        }));
      });
    },
    handleDetail(record) {
      this.curData = { ...record };
      this.showDetail = true;
      return request
        .get("/emm/emmStockInfo/getByStockId", { params: record })
        .then((res) => {
          res.data.items.forEach((item) => {
            item.totals = (item.stockNum * item.price).toFixed(2);
          });
          this.detailData = res.data;
          this.detailData.alias = record.additionalInfo.alias
        });
    },
    getLabel(field, val) {
      const arr = this[field];
      if (!arr) {
        return val;
      }
      const obj = arr.find((item) => item.value == val);
      return obj ? obj.text : val;
    },
    getCbxz() {
      return request.get("/system/dict/list/table?code=ccdj").then((res) => {
        this.storageLevel = [
          { value: "", text: "无" },
          ...res.data.map((item) => ({
            value: item.code,
            text: item.name,
          })),
        ];
      });
    },
    getWzfl() {
      return request
        .get("/emm/emmStockInfo/emmSpecification", {
          params: { status: 0 },
        })
        .then((res) => {
          this.classificationCode = [
            { value: "", text: "无" },
            ...res.data.map((item) => ({
              value: item.classificationCode,
              text: item.classificationName,
            })),
          ];
        });
    },
    getWzmc() {
      return request
        .get("/emm/emmStockInfo/emmSpecification", {
          params: {
            status: 1,
            classificationCode: this.form.classificationCode,
          },
        })
        .then((res) => {
          this.codes = [
            { value: "", text: "无" },
            ...res.data.map((item) => ({
              value: item.emmCode,
              text: item.emmName + " - " + item.brand + " - " + item.model,
            })),
          ];
        });
    },
    reset() {
      this.form = {
        wz: "",
        codes: "",
        classificationCode: null,
        storageLevel: "",
        manageMode: "",
      };
      this.nameObj = {
        classificationCode: null,
        storageLevel: "",
        manageMode: "",
      };
      this.getWzmc();
      let that = this
      setTimeout(()=>{
        that.$refs.Select.into();
      },100)
      
    },
    onConfirm(value) {
      this.form[this.field] = value.value;
      this.nameObj[this.field] = value.value ? value.text : "";
      this.showPicker = false;
      if (this.field == "classificationCode") {
        this.getWzmc();
        this.form.codes = "";
        this.nameObj.codes = "";
      }
    },
    showPickerFn(columns) {
      this.field = columns;
      this.columns = this[columns];
      this.showPicker = true;
    },
    getData(page) {
      this.loading = true;
      return request
        .get("/emm/emmStockInfo/pageListByWarehouse", {
          params: { ...this.form, page },
        })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.records;
          res.data.records.forEach((item) => {
            item.storageLevel = this.getLabel(
              "storageLevel",
              item.storageLevel
            );
            item.manageMode = this.getLabel("manageMode", item.manageMode);
          });
          this.pageCount = res.data.pages;
        });
    },
  },
  async mounted() {
    await this.getCbxz();
    await this.getWzfl();
    await this.getWzmc();
    await this.getSt();
    this.getData();
    // this.tableData = this.AllData;
    this.$parent.showPanDian = true;
  },
  destroyed() {
    this.$parent.showPanDian = false;
  },
};
</script>
<style lang="scss">
.ss_col {
  .com_field {
    width: calc(100% - 20px);
    border: 1px solid #ccc;
    margin: 0 10px 10px 10px;
    padding: 4px 10px;
    border-radius: 4px;
  }
}
</style>
<style scoped>
.container-box {
  height: 100%;
}
.main {
  height: 100%;
  overflow-y: auto;
  background: #f6f6f6;
}
.filter {
  background: #fff;
  padding: 0 10px;
}
.van-field {
  width: calc(100% - 20px);
  border: 1px solid #ccc;
  margin: 0 10px 10px 10px;
  padding: 4px 10px;
  border-radius: 4px;
}
.filter-btn {
  text-align: right;
}
.filter-btn button {
  margin-right: 10px;
}
.table-box {
  padding-top: 10px;
  background: #fff;
  height: calc(100% - 130px);
}
.table {
  width: 100%;
  height: calc(100% - 40px);
}
.popup-table {
  width: 100%;
  height: calc(100% - 37px);
  overflow-y: hidden;
  overflow-x: auto;
}

.scan {
  display: inline-block;
  position: relative;
}
.scan-ipt {
  width: calc(100% - 10px);
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
</style>
